const WorkflowRecordModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    isEditing: false,
    idx: ''
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload
    },
    IS_EDITING: (state, payload) => {
      state.isEditing = payload
    },
    SET_IDX: (state, payload) => {
      state.idx = payload
    },
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    UPDATE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    },
    INSERT: (state, payload) => {
      state.data.push(payload)
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/workflow/workflow_record/get`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        const response = await axios.delete(`/workflow/workflow_record/delete/${payload}`)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Deleted!',
            position: 'bottomRight'
          })
        }
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async update({ commit, dispatch }, payload) {
      try {
        const response = await axios.put(`/workflow/workflow_record/update`, payload)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Updated!',
            position: 'bottomRight'
          })
        }
        dispatch('fetch')
        commit('UPDATE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/workflow/workflow_record/insert`, payload)
        if (response.data.message === true) {
          iziToast.success({
            title: 'Created!',
            position: 'bottomRight'
          })
          dispatch('fetch')
          commit('INSERT', payload)
          return response.data.workflowRecordId
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    },
    getById: state => payload => {
      return state.data.filter(item => item.idx.match(payload))
    }
  }
}

export default WorkflowRecordModule



// WEBPACK FOOTER //
// ./src/store/modules/workflow/workflow_record.js